import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
import { Alert, AlertDescription } from "@/components/alert";
import Footer from '../../../components/Footer';
import MtechImg from "../../../assets/images/engineering.jpeg";
import Title from '../../../components/TitleComponent';


const programDetails = {
    name: "M.Tech in Data Science",
    about: "M.Tech. (Master of Technology) in Data Science is a postgraduate degree program that focuses on advanced concepts, techniques, and technologies related to data science. The course covers techniques for extracting valuable insights and patterns from large datasets and emphasizes distributed computing frameworks such as Hadoop and Spark. Students also learn about tools for data storage, retrieval, and processing, and may undertake research components involving identifying problems, designing experiments, and presenting findings.",
    eligibility: "Merit prepared on the basis of B.Tech (Mechanical/Electrical/Electronics), MCA, M.Sc, or MDU Entrance examination",
};

const programFees = {
    program: "Master of Technology (M.Tech)",
    branch: "Data Science",
    duration: "2",
    seats: "20",
    // registrationFee: "16000",
    // allIndiaFee: "100000",
    // ukDomicileFee: "75000",
};

const MtechDataScience = () => {
    return (
        <div className="w-full relative font-poppins bg-gray-50">
            <Title canonicalPath="/programmes/pg-courses/engineering/mtech/data-science-engineering
" />
            <Title title="M.Tech in Data Science Colleges in India | Top Institutes
" description="Explore the best M.Tech in Data Science colleges in India. Discover top institutes offering advanced education, research opportunities, and career growth in data science.
" />
            <div className="w-11/12 lg:w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 pb-16">
                <Card className="border-none shadow-lg">
                    <CardHeader className="space-y-4 text-center">
                        <CardTitle className="text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]">
                            {programDetails.name}
                        </CardTitle>
                        <div className="w-20 h-1 bg-[#23376c] mx-auto"></div>
                    </CardHeader>
                    <CardContent>
                        <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between">
                            <div className="md:w-[30%] relative group">
                                <img
                                    src={MtechImg}
                                    className="rounded-lg w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                                    alt="M.Tech Data Science"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
                            </div>
                            <div className="flex flex-col gap-4 md:w-[65%]">
                                <h4 className="font-bold text-xl md:text-3xl text-[#23376c]">About the Department</h4>
                                <p className="text-justify md:text-lg text-gray-700 leading-relaxed">{programDetails.about}</p>
                                <Link to="https://admission.maya.edu.in/">
                                    <button className="mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] hover:shadow-lg transform hover:-translate-y-1">
                                        Register Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                <Card className="border-none shadow-lg">
                    <CardContent className="mt-5 p-6">
                        <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4">Eligibility Criteria</h4>
                        <p className="text-gray-700 leading-relaxed">{programDetails.eligibility}</p>
                    </CardContent>
                </Card>

                {/* Program Fee Table */}
                <Card className="border-none shadow-lg">
                    <CardContent className="p-0">
                        {/* Scrollable container for responsive table */}
                        <div className="overflow-x-auto">
                            <Table className="min-w-full">
                                <TableHeader>
                                    <TableRow className="bg-[#23376c]">
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Programme</TableHead>
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Branch</TableHead>
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Duration</TableHead>
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Seats</TableHead>
                                        {/* <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Registration Fee</TableHead>
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Yearly Fee (All India)</TableHead>
                                        <TableHead className="text-white font-semibold px-2 py-1 text-xs md:text-sm">Yearly Fee (UK Domicile)</TableHead> */}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    <TableRow className="hover:bg-gray-50">
                                        <TableCell className="font-medium px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {programFees.program}
                                        </TableCell>
                                        <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {programFees.branch}
                                        </TableCell>
                                        <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {programFees.duration}
                                        </TableCell>
                                        <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {programFees.seats}
                                        </TableCell>
                                        {/* <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {`₹${programFees.registrationFee}/-`}
                                        </TableCell>
                                        <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {`₹${programFees.allIndiaFee}/-`}
                                        </TableCell>
                                        <TableCell className="px-2 py-1 text-xs md:text-sm whitespace-nowrap">
                                            {`₹${programFees.ukDomicileFee}/-`}
                                        </TableCell> */}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </CardContent>
                </Card>



            </div>
            <Footer />
        </div>
    );
};

export default MtechDataScience;
